module.exports = __webpack_public_path__ + "fonts/CircularStd-Bold.6baed2bf.otf";